import React, { Component, useContext } from 'react'
import { PARTY_COLORS } from '../../constants/colors'
import { isBrowser } from 'react-device-detect'
import { Grid, Segment } from 'semantic-ui-react'

import { LocaleContext } from 'contexts/locale'
import './styles.scss'

// import { ListComponent } from 'components/list/component'
// import listSitzverteilung from 'stores/nationalrat-data.csv'

type Props = {
  data: string[]
}

type State = {
  isLoading: boolean
  locale: string[]
  globalLocale: string[]
}

const initialState = {
  isLoading: false,
  locale: [],
  globalLocale: []
}

export class Dashboard extends Component<Props, State> {
  state = initialState

  render() {
    const _locale = this.context
    const locale = require('./locales/' + _locale + '.yml')
    const globalLocale = require('locales/' + _locale + '.yml')

    console.log(this.props.data)

    const Parties = this.props.data
      .sort((a, b) => a.sort - b.sort)
      .map((el, index) => (
        <Grid.Column key={el.fraktion + index} className='dashboard-column'>
          <table
            className='ui very basic compact two column mini unstackable table'
            style={{ position: 'relative' }}
          >
            <tbody>
              <tr>
                <td className='fraction-lines'>
                  <span
                    className='middle-line'
                    style={{
                      display: 'block',
                      background: PARTY_COLORS[el.groupCode]
                    }}
                  />
                  <span
                    className={`left-line ${el.option}`}
                    style={{
                      background: PARTY_COLORS[el.groupCode]
                    }}
                  />
                </td>
                <td style={{ width: 'auto' }}>
                  <div
                    className={`square ${el.fraktion}`}
                    style={{ background: PARTY_COLORS[el.code] }}
                  />
                </td>
                <td>
                  <strong>{globalLocale.UI.Global.Fractions[el.code]}</strong>
                </td>
                <td className='right aligned'>
                  <div className='parteiName'>
                    {el.sitze}
                    {isBrowser && parseInt(el.sitze) === 1 && locale.Sitz}
                    {isBrowser && parseInt(el.sitze) !== 1 && locale.Sitze}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid.Column>
      ))

    return (
      <div className='dashboard-element'>
        <Grid unstackable columns={2} className='dashboard-grid'>
          {Parties}
        </Grid>
      </div>
    )
  }
}

Dashboard.contextType = LocaleContext
